import React, { useContext } from 'react';

import { User } from './authContext.types';

export const AuthContext = React.createContext<AuthContextValue>({
  user: undefined,
  userId: undefined,
  isLoading: true,
  canLogin: true,
  logout: () => Promise.reject(),
  login: () => Promise.reject(),
  clearSessions: () => Promise.reject(),
});

export interface AuthAppState {
  targetUrl?: string;
}

export interface LoginParams {
  appState?: AuthAppState;
}

export interface AuthContextValue {
  isLoading: boolean;
  user: User | undefined;
  userId: string | undefined;
  canLogin: boolean;
  login: (params?: LoginParams) => Promise<void>;
  logout: () => Promise<void>;
  clearSessions: () => Promise<void>;
}

export interface AuthProviderProps {
  onRedirectCallback?: (appState?: AuthAppState) => any;
}

export const useAuth = () => useContext(AuthContext);
